import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { Erro403Component } from './erros';
import { AuthGuard } from './autenticacao/auth.guard';
import { ModulosComponent } from './modulos';

const routes: Routes = [
    { path: 'erro/403', component: Erro403Component },
    { path: '', redirectTo: 'sistema/modulos', canActivateChild: [AuthGuard], pathMatch: 'full' },
    { path: 'menu', redirectTo: 'menu/pessoa-fisica', canActivateChild: [AuthGuard], pathMatch: 'full' },
    {
        path: 'sistema', canActivateChild: [AuthGuard], children: [
            {
                path: 'modulos', data: { Breadcrumb: "Página Inicial", Menu: "Sistema" }, children: [
                    { path: '', component: ModulosComponent },
                    { path: ':acao', component: ModulosComponent },
                    { path: ':acao/:id', component: ModulosComponent }
                ]
            },
        ]
    },
    {
        path: 'parametrizacao', redirectTo: 'orgao-expedidor', canActivateChild: [AuthGuard], pathMatch: 'full'
    },
    {
        path: 'menu', canActivateChild: [AuthGuard], children: [
            {
                path: 'pessoa-fisica', data: { Breadcrumb: "Pessoa Física", Menu: "Registro" }, children: [
                    { path: '', loadChildren: "./pessoa-fisica/pessoa-fisica.module#PessoaFisicaModule" },
                    { path: ':acao', loadChildren: "./pessoa-fisica/pessoa-fisica.module#PessoaFisicaModule" },
                    { path: ':acao/:id', loadChildren: "./pessoa-fisica/pessoa-fisica.module#PessoaFisicaModule" }
                ]
            },
            {
                path: 'pessoa-juridica', data: { Breadcrumb: "Pessoa Jurídica", Menu: "Registro" }, children: [
                    { path: '', loadChildren: "./pessoa-juridica/pessoa-juridica.module#PessoaJuridicaModule" },
                    { path: ':acao', loadChildren: "./pessoa-juridica/pessoa-juridica.module#PessoaJuridicaModule" }, //CRUD
                    { path: ':acao/:id', loadChildren: "./pessoa-juridica/pessoa-juridica.module#PessoaJuridicaModule" } //CRUD
                ]
            }
        ]
    },
    {
        path: 'parametrizacao', canActivateChild: [AuthGuard], children: [
            {
                path: 'conselho-regional', data: { Breadcrumb: "Conselho Regional", Menu: "Parametrização" }, children: [
                    { path: '', loadChildren: "./conselho-regional/conselho-regional.module#ConselhoRegionalModule" },
                    { path: ':acao', loadChildren: "./conselho-regional/conselho-regional.module#ConselhoRegionalModule" }, //CRUD
                    { path: ':acao/:id', loadChildren: "./conselho-regional/conselho-regional.module#ConselhoRegionalModule" }, //CRUD
                ]
            },
            {
                path: 'orgao-expedidor', data: { Breadcrumb: "Orgão Expedidor", Menu: "Parametrização" }, children: [
                    { path: '', loadChildren: "./orgao-expedidor/orgao-expedidor.module#OrgaoExpedidorModule" },
                    { path: ':acao', loadChildren: "./orgao-expedidor/orgao-expedidor.module#OrgaoExpedidorModule" }, //CRUD
                    { path: ':acao/:id', loadChildren: "./orgao-expedidor/orgao-expedidor.module#OrgaoExpedidorModule" } //CRUD
                ]
            },
            {
                path: 'profissao', data: { Breadcrumb: "Profissão", Menu: "Parametrização" }, children: [
                    { path: '', loadChildren: "./profissao/profissao.module#ProfissaoModule" },
                    { path: ':acao', loadChildren: "./profissao/profissao.module#ProfissaoModule" }, //CRUD
                    { path: ':acao/:id', loadChildren: "./profissao/profissao.module#ProfissaoModule" } //CRUD
                ]
            },
            {
                path: 'delegacia', data: { Breadcrumb: "Delegacia", Menu: "Parametrização" }, children: [
                    { path: '', loadChildren: "./delegacia/delegacia.module#DelegaciaModule" },
                    { path: ':acao', loadChildren: "./delegacia/delegacia.module#DelegaciaModule" }, //CRUD
                    { path: ':acao/:id', loadChildren: "./delegacia/delegacia.module#DelegaciaModule" } //CRUD
                ]
            },
            {
                path: 'oficio', data: { Breadcrumb: "Ofício", Menu: "Parametrização" }, children: [
                    { path: '', loadChildren: "./oficio/oficio.module#OficioModule" },
                    { path: ':acao', loadChildren: "./oficio/oficio.module#OficioModule" }, //CRUD
                    { path: ':acao/:id', loadChildren: "./oficio/oficio.module#OficioModule" } //CRUD
                ]
            }
        ]
    },
    {
        path: 'instituicao-ensino', canActivateChild: [AuthGuard], children: [
            {
                path: 'tipo-titulo', data: { Breadcrumb: "Tipo Título", Menu: "Instituição Ensino" }, children: [
                    { path: '', loadChildren: "./curso/curso.module#CursoModule" },
                    { path: ':acao', loadChildren: "./curso/curso.module#CursoModule" }, //CRUD
                    { path: ':acao/:id', loadChildren: "./curso/curso.module#CursoModule" } //CRUD
                ]
            },
            {
                path: 'natureza-titulo', data: { Breadcrumb: "Natureza Título", Menu: "Instituição Ensino" }, children: [
                    { path: '', loadChildren: "./natureza-titulo/natureza-titulo.module#NaturezaTituloModule" },
                    { path: ':acao', loadChildren: "./natureza-titulo/natureza-titulo.module#NaturezaTituloModule" }, //CRUD
                    { path: ':acao/:id', loadChildren: "./natureza-titulo/natureza-titulo.module#NaturezaTituloModule" } //CRUD
                ]
            },
            {
                path: 'area-formacao', data: { Breadcrumb: "Área Formação", Menu: "Instituição Ensino" }, children: [
                    { path: '', loadChildren: "./area-formacao/area-formacao.module#AreaFormacaoModule" },
                    { path: ':acao', loadChildren: "./area-formacao/area-formacao.module#AreaFormacaoModule" }, //CRUD
                    { path: ':acao/:id', loadChildren: "./area-formacao/area-formacao.module#AreaFormacaoModule" } //CRUD
                ]
            },
            {
                path: 'instituicao', data: { Breadcrumb: "Instituição", Menu: "Instituição Ensino" }, children: [
                    { path: '', loadChildren: "./instituicao-ensino/instituicao-ensino.module#InstituicaoEnsinoModule" },
                    { path: ':acao', loadChildren: "./instituicao-ensino/instituicao-ensino.module#InstituicaoEnsinoModule" }, //CRUD
                    { path: ':acao/:id', loadChildren: "./instituicao-ensino/instituicao-ensino.module#InstituicaoEnsinoModule" } //CRUD
                ]
            }
        ]
    },
    {
        path: 'servicos', canActivateChild: [AuthGuard], children: [
            {
                path: 'gerenciar-servico', data: { Breadcrumb: "Gerenciar Serviços", Menu: "Serviços" }, children: [
                    { path: '', loadChildren: "./gerenciar-servico/gerenciar-servico.module#GerenciarServicoModule" },
                    { path: ':acao', loadChildren: "./gerenciar-servico/gerenciar-servico.module#GerenciarServicoModule" }, //CRUD
                    { path: ':acao/:id', loadChildren: "./gerenciar-servico/gerenciar-servico.module#GerenciarServicoModule" } //CRUD
                ]
            },
            {
                path: 'gerenciar-servico-pessoa-juridica', data: { Breadcrumb: "Gerenciar Serviços de Pessoa Jurídica", Menu: "Serviços" }, children: [
                    { path: '', loadChildren: "./gerenciar-servico-pessoa-juridica/gerenciar-servico-pessoa-juridica.module#GerenciarServicoPessoaJuridicaModule" },
                    { path: ':acao', loadChildren: "./gerenciar-servico-pessoa-juridica/gerenciar-servico-pessoa-juridica.module#GerenciarServicoPessoaJuridicaModule" },
                    { path: ':acao/:id', loadChildren: "./gerenciar-servico-pessoa-juridica/gerenciar-servico-pessoa-juridica.module#GerenciarServicoPessoaJuridicaModule" } 
                ]
            },
            {
                path: 'gerenciar-servico-gestor', data: { Breadcrumb: "Gerenciar Serviços Gestor", Menu: "Serviços" }, children: [
                    { path: '', loadChildren: "./gerenciar-servico-gestor/gerenciar-servico-gestor.module#GerenciarServicoGestorModule" }, //GerenciarServicoGestorComponent
                    { path: 'encaminhar/:id', loadChildren: "./gerenciar-servico-gestor/gerenciar-servico-gestor.module#GerenciarServicoGestorModule" }, //EncaminharServicoComponent
                    { path: ':acao', loadChildren: "./gerenciar-servico-gestor/gerenciar-servico-gestor.module#GerenciarServicoGestorModule" }, //CRUD
                    { path: ':acao/:id', loadChildren: "./gerenciar-servico-gestor/gerenciar-servico-gestor.module#GerenciarServicoGestorModule" } //CRUD
                ]
            },
            {
                path: 'fila-servico', data: { Breadcrumb: "Fila de Serviço", Menu: "Serviços" }, children: [
                    { path: '', loadChildren: "./fila-servico/fila-servico.module#FilaServicoModule" },
                    { path: ':acao', loadChildren: "./fila-servico/fila-servico.module#FilaServicoModule" },
                ]
            }
        ]
    },
    {
        path: 'cnaipj', canActivateChild: [AuthGuard], children: [
            {
                path: 'solicitacao-cnaipj', data: { Breadcrumb: "Solicitação", Menu: "CNAIPJ" }, children: [
                    { path: '', loadChildren: "./solicitacao-cnaipj/solicitacao-cnaipj.module#SolicitacaoCnaipjModule" },
                    { path: ':acao', loadChildren: "./solicitacao-cnaipj/solicitacao-cnaipj.module#SolicitacaoCnaipjModule" }, //CRUD
                    { path: ':acao/:id', loadChildren: "./solicitacao-cnaipj/solicitacao-cnaipj.module#SolicitacaoCnaipjModule" } //CRUD
                ]
            },
            {
                path: 'homologacao-cnaipj', data: { Breadcrumb: "Homologação", Menu: "CNAIPJ" }, children: [
                    { path: '', loadChildren: "./homologacao-cnaipj/homologacao-cnaipj.module#HomologacaoCnaipjModule" },
                    { path: ':acao/:id', loadChildren: "./homologacao-cnaipj/homologacao-cnaipj.module#HomologacaoCnaipjModule" } //CRUD
                ]
            }
        ]
    },
    {
        path: 'documentos', children: [
            {
                path: 'certidao', data: { possui: 'Certidao', Breadcrumb: "Certidão", Menu: "Documentos" }, children: [
                    { path: '', loadChildren: "./certidao/certidao.module#CertidaoModule" },
                    { path: ':acao', loadChildren: "./certidao/certidao.module#CertidaoModule" } //CRUD
                ]
            },
            {
                path: 'certidao-cnaipj', data: { possui: 'CertidaoCnaipj', Breadcrumb: "Certidão CNAIPJ", Menu: "Documentos" }, children: [
                    { path: '', loadChildren: "./certidao-cnaipj/certidao-cnaipj.module#CertidaoCnaipjModule" },
                    { path: ':acao', loadChildren: "./certidao-cnaipj/certidao-cnaipj.module#CertidaoCnaipjModule" } //CRUD
                ]
            },
            {
                path: 'alvara', data: { possui: 'Alvara', Breadcrumb: "Alvará", Menu: "Documentos" }, children: [
                    { path: '', loadChildren: "./alvara/alvara.module#AlvaraModule" },
                    { path: ':acao', loadChildren: "./alvara/alvara.module#AlvaraModule" } //CRUD
                ]
            },
            {
                path: 'validar-documentos', data: { Breadcrumb: "Validar Documentos", Menu: "Documentos" }, children: [
                    { path: '', loadChildren: "./validar-documentos/validar-documentos.module#ValidarDocumentosModule" },
                ],
            }
        ]
    },
    {
        path: 'comunicacao', canActivateChild: [AuthGuard], children: [
            {
                path: 'solicitar-comunicacao', data: { Breadcrumb: "Solicitar Comunicação", Menu: "Comunicação" }, children: [
                    { path: '', loadChildren: "./solicitar-comunicacao/solicitar-comunicacao.module#SolicitarComunicacaoModule" },
                    { path: ':acao', loadChildren: "./solicitar-comunicacao/solicitar-comunicacao.module#SolicitarComunicacaoModule" }, //CRUD
                    { path: ':acao/:id', loadChildren: "./solicitar-comunicacao/solicitar-comunicacao.module#SolicitarComunicacaoModule" } //CRUD
                ]
            },
            {
                path: 'consultar-comunicacao', data: { Breadcrumb: "Consultar Comunicação", Menu: "Comunicação" }, children: [
                    { path: '', loadChildren: "./consultar-comunicacao/consultar-comunicacao.module#ConsultarComunicacaoModule" },
                    { path: ':acao/:id', loadChildren: "./consultar-comunicacao/consultar-comunicacao.module#ConsultarComunicacaoModule" } //CRUD
                ]
            }
        ]
    },
    {
        path: 'consultas', children: [
            {
                path: 'registros-delegacia', data: { Breadcrumb: "Registro Delegacia", Menu: "Consultas" }, children: [
                    { path: '', loadChildren: "./registros-delegacia/registros-delegacia.module#RegistrosDelegaciaModule" }, //RegistrosDelegaciaComponent
                ]
            },
            {
                path: 'registros-delegacia-cidade', data: { Breadcrumb: "Registro Delegacia Cidade", Menu: "Consultas" }, children: [
                    { path: '', loadChildren: "./registros-delegacia/registros-delegacia.module#RegistrosDelegaciaModule" }, //RegistrosDelegaciaCidadeComponent
                ]
            },
            {
                path: 'situacao-cadastral', data: { Breadcrumb: "Situação Cadastral", Menu: "Consultas" }, children: [
                    { path: '', loadChildren: "./consultar-situacao-cadastral/consultar-situacao-cadastral.module#ConsultarSituacaoCadastralModule" }, //ConsultarSituacaoCadastralComponent
                ]
            },
            {
                path: 'consulta-pessoa-fisica', data: { Breadcrumb: "Pessoa Física", Menu: "Consultas" }, children: [
                    { path: '', loadChildren: "./consultar-pessoa-fisica/consultar-pessoa-fisica.module#ConsultarPessoaFisicaModule" }, //ConsultarPessoaFisicaComponent
                    { path: ':acao/:id', loadChildren: "./consultar-pessoa-fisica/consultar-pessoa-fisica.module#ConsultarPessoaFisicaModule" } //CRUD
                ]
            },
            {
                path: 'consulta-pessoa-juridica', data: { Breadcrumb: "Pessoa Jurídica", Menu: "Consultas" }, children: [
                    { path: '', loadChildren: "./consultar-pessoa-juridica/consultar-pessoa-juridica.module#ConsultarPessoaJuridicaModule" }, //ConsultarPessoaJuridicaComponent
                    { path: ':acao/:id', loadChildren: "./consultar-pessoa-juridica/consultar-pessoa-juridica.module#ConsultarPessoaJuridicaModule" } //CRUD
                ]
            },
            {
                path: 'consulta-cnaipj', data: { Breadcrumb: "CNAIPJ", Menu: "Consultas" }, children: [
                    { path: '', loadChildren: "./consultar-cnaipj/consultar-cnaipj.module#ConsultarCnaipjModule" }, //ConsultaPublicaCnaipj
                    { path: ':acao/:id', loadChildren: "./consultar-cnaipj/consultar-cnaipj.module#ConsultarCnaipjModule" } //CRUD
                ]
            }
        ]
    }
];


export const AppRoutes: ModuleWithProviders = RouterModule.forRoot(routes);



// WEBPACK FOOTER //
// ./src/app/app.routes.ts